import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { spotFinder } from './endpoints';
import axiosBaseQuerySpotfinder from './axiosBaseQuerySpotfinder';

// Define a service using a base URL and expected endpoints
export const feedbacksApi = createApi({
  reducerPath: 'feedbacksApi',
  baseQuery: axiosBaseQuerySpotfinder({ baseUrl: process.env.REACT_APP_SPOT_FINDER_BASE_URL }),
  tagTypes: ['feedbacks'],
  endpoints: (builder) => ({
    findAllCustomerFeedback: builder.mutation({
      query(body) {
        return {
          url: spotFinder.customerFeedbackController.findAllCustomerFeedback,
          method: 'POST',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
    findCustomerFeedbackById: builder.mutation({
      query({ Id, token }) {
        return {
          url: `${spotFinder.customerFeedbackController.findCustomerFeedbackById}/${Id}`,
          method: 'GET',
          headers: { Authorization: `Bearer ${token}` },  
        };
      },
    }),
    getAllCustomerFeedback: builder.mutation({
      query({ token, payload }) {
          return {
              url: `${spotFinder.customerFeedbackController.getAllCustomerFeedback}`,
              method: "POST",
              headers: token ? { Authorization: `Bearer ${token}` } : {},
              body: payload,
          };
      },
  }),
    findCustomerFeedbackByBookingId: builder.mutation({
      query({ bookingId, token }) {
        return {
          url: `${spotFinder.customerFeedbackController.findCustomerFeedbackByBookingId}/${bookingId}`,
          method: 'GET',
          headers: { Authorization: `Bearer ${token}` },  
        };
      },
    }),
    saveCustomerFeedback: builder.mutation({
      query(body) {
        return {
          url: spotFinder.customerFeedbackController.saveCustomerFeedback,
          method: 'POST',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.reqData,
        };
      },
    }),
    updateCustomerFeedback: builder.mutation({
      query({ payload, token }) {  
        return {
          url: spotFinder.customerFeedbackController.updateCustomerFeedback,
          method: 'PUT',
          headers: { Authorization: `Bearer ${token}` },
          body: payload,
        };
      },
    }),
    deleteCustomerFeedback: builder.mutation({
      query({ Id, token }) {
        return {
          url: `${spotFinder.customerFeedbackController.deleteCustomerFeedback}/${Id}`,
          method: 'DELETE',
          headers: { Authorization: `Bearer ${token}` },  
        };
      },
    }),
  }),
});
// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useFindAllCustomerFeedbackMutation,
  useFindCustomerFeedbackByIdMutation,
  useGetAllCustomerFeedbackMutation,
  useFindCustomerFeedbackByBookingIdMutation,
  useSaveCustomerFeedbackMutation,
  useUpdateCustomerFeedbackMutation,
  useDeleteCustomerFeedbackMutation,
} = feedbacksApi;
